// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// Freemium Config – Master Toggle
// Auf `true` setzen wenn die App in den App Store geht.
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
export const FREEMIUM_ENABLED = true;

// localStorage key für Premium-Status
export const PREMIUM_KEY = 'bullivo_premium_v1';

// Free-Tier Limits
export const FREE_LIMITS = {
  homeSignals: 3,         // Max Signale auf Home
  discoverSignals: 5,     // Max Signale im Discover-Feed (Rest → Paywall)
  portfolioAssets: null,   // Watchlist unbegrenzt
  chartPeriods: null,      // Alle Charts frei
  newsEnabled: true,       // News bleibt frei
  alertsEnabled: false,    // Push-Alerts = Premium
  analyseTrends: 1,        // Nur 1 von 3+ Trends sichtbar, Rest = Premium
};

// Premium Features für Paywall-UI
export const PREMIUM_FEATURES = [
  { icon: '📊', title: 'Alle Signale', desc: 'Zugang zu allen 20+ Kaufempfehlungen' },
  { icon: '🔔', title: 'Push-Alerts', desc: 'Sofort-Benachrichtigung bei Kauf- und Verkaufssignalen' },
  { icon: '🚨', title: 'Breaking News', desc: 'Echtzeit-Alerts bei marktbewegenden Nachrichten' },
  { icon: '✦', title: 'Volle KI-Analyse', desc: 'Alle Trends, Picks und Markteinschätzungen' },
];
